import Layout from '@/layout/index.vue';
var financialRouter = {
  path: '/data',
  component: Layout,
  redirect: '/data/deposit-statistics',
  name: 'Data',
  meta: {
    title: '数据分析'
  },
  children: [{
    path: 'financial',
    component: function component() {
      return import('@/views/data/index.vue');
    },
    name: 'DataFinancial',
    meta: {
      title: '财务分析'
    },
    children: [{
      path: 'deposit-statistics',
      name: 'DataFinancialDepositStatistics',
      component: function component() {
        return import('@/views/data/financial/deposit-statistics/index.vue');
      },
      meta: {
        title: '充值统计'
      }
    }, {
      path: 'withdraw-statistics',
      name: 'DataFinancialWithdrawStatistics',
      component: function component() {
        return import('@/views/data/financial/withdraw-statistics/index.vue');
      },
      meta: {
        title: '提现统计'
      }
    }]
  }, {
    path: 'product',
    component: function component() {
      return import('@/views/data/index.vue');
    },
    name: 'DataProduct',
    meta: {
      title: '产品分析'
    },
    children: [{
      path: 'lottery-analysis',
      component: function component() {
        return import('@/views/data/product/lottery-analysis/index.vue');
      },
      name: 'DataProductLotteryAnalysis',
      meta: {
        title: '彩票打码分析'
      }
    }, {
      path: 'game-analysis',
      component: function component() {
        return import('@/views/data/product/game-analysis/index.vue');
      },
      name: 'DataProductGameAnalysis',
      meta: {
        title: '游戏打码分析'
      }
    }]
  }, {
    path: 'ad',
    component: function component() {
      return import('@/views/data/index.vue');
    },
    name: 'DataAd',
    meta: {
      title: '广告分析'
    },
    children: [{
      path: 'payback-analysis',
      name: 'DataAdPaybackAnalysis',
      component: function component() {
        return import('@/views/data/ad/payback-analysis/index');
      },
      meta: {
        title: '投放回收分析'
      }
    }, {
      path: 'spend-statistics',
      name: "DataAdSpendStatistics",
      meta: {
        title: '投放费用统计'
      },
      component: function component() {
        return import('@/views/data/ad/spend-statistics/index');
      }
    }]
  }]
};
export default financialRouter;